import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import "./styles.scss";

function SubMenu({ title, menuItems, openSubMenu }) {
	return (
		<div
			className="submenu"
			aria-hidden={openSubMenu === title ? "false" : "true"}
		>
			<div className="section section--is-green section--is-paddingless">
				<div className="container">
					<nav>
						<ul className="submenu__items">
							{menuItems.map((subMenuItem, index) => (
								<li className="submenu__item" key={index}>
									<Link to={`/${subMenuItem.slug}`} className="submenu__link">
										<div
											dangerouslySetInnerHTML={{
												__html: subMenuItem.icon.svg.content,
											}}
										/>
										<div className="submenu__heading">{subMenuItem.title}</div>
										<div>{subMenuItem.description}</div>
									</Link>
								</li>
							))}
						</ul>
					</nav>
				</div>
			</div>
		</div>
	);
};

export default SubMenu;

SubMenu.propTypes = {
	title: PropTypes.string,
	menuItems: PropTypes.arrayOf(
		PropTypes.shape({
			contentful_id: PropTypes.string,
			description: PropTypes.string,
			icon: PropTypes.shape({
				svg: PropTypes.shape({
					content: PropTypes.string,
				}),
			}),
			slug: PropTypes.string,
			title: PropTypes.string,
		})
	),
	openSubMenu: PropTypes.string,
};
